import {UserStatisticsApi} from "api/UserStatisticsApi";
import {UserDataApi} from "../UserDataApi";
import {IQueryOptions, QueryKey, useQueryWrapper} from "./api-hooks-common";

export const useGetUserInfo = (username?: string | number, options?: IQueryOptions) => useQueryWrapper([QueryKey.USER_INFO, username], () => UserDataApi.getDataInfo(username), null, options);

export const useGetCurrentUser = (options?: IQueryOptions) => useQueryWrapper([QueryKey.USER_INFO], () => UserDataApi.getCurrentUser(), null, options )

export const useGetUsersSessions = (dateFrom: string, dateTo: string, companyReference?: string, jobTitle?: string, options?: IQueryOptions) => useQueryWrapper([QueryKey.USER_SESSIONS, dateFrom, dateTo, companyReference, jobTitle], () => UserStatisticsApi.getUsersSessions(dateFrom, dateTo, companyReference, jobTitle), null, options);
